import React from "react"
import Icon from "@convertkit/design/icon"
import Badge from "@convertkit/design/badge"
import { Link } from "react-rb"
import { MenuLink } from "@reach/menu-button"

const NavLink = ({
  href,
  icon,
  iconColor,
  label,
  content,
  isCreatorFeat = false,
  canUseFeat = true,
  newTab = false,
  showBetaBadge = false
}) => {
  const ICON_STYLES = "mr-4 overflow-visible"
  const LINK_STYLES =
    "h-full flex p-2 rounded hover:no-underline hover:text-gray-900 focus:outline-blue focus:no-underline focus:bg-gray-50"
  const showCreatorBadge = isCreatorFeat && !canUseFeat
  return (
    <MenuLink
      as={Link}
      to={href}
      className={`main-link ${LINK_STYLES}`}
      target={newTab ? "_blank" : undefined}
    >
      <Icon name={icon} className={`${ICON_STYLES} ${iconColor}`} aria-hidden />
      <div className="leading-6">
        <div className="font-semibold text-base flex items-center text-gray-900">
          {label}
          {showCreatorBadge && (
            <Badge color="blue" variant="light" className="ml-2">
              Creator
            </Badge>
          )}
          {showBetaBadge && (
            <Badge color="yellow" variant="light" className="ml-2">
              Beta
            </Badge>
          )}
        </div>
        <p className="mt-2 text-gray-800">{content}</p>
      </div>
    </MenuLink>
  )
}

export default NavLink
